import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImage,
  faDownload,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import "./BottomBar.css";

const BottomBar = ({
  exportCardAsImage,
  handleSendEmail,
  handleEditBackground,
}) => {
  const fileInputRef = useRef(null);

  const triggerFileUpload = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="bottom-bar">
      {/* Hidden File Input */}
      <input
        type="file"
        ref={fileInputRef}
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleEditBackground}
      />

      {/* Left-aligned Edit Background Button */}
      <div className="left-buttons">
        <button className="action-btn edit-btn" onClick={triggerFileUpload}>
          <FontAwesomeIcon icon={faImage} className="btn-icon" />
          Edit Background
        </button>
      </div>

      {/* Right-aligned Send & Download Buttons */}
      <div className="right-buttons">
        <button className="action-btn send-btn" onClick={handleSendEmail}>
          <FontAwesomeIcon icon={faPaperPlane} className="btn-icon" />
          Send
        </button>
        <button className="action-btn download-btn" onClick={exportCardAsImage}>
          <FontAwesomeIcon icon={faDownload} className="btn-icon" />
          Download
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
